import { Stack, router } from 'expo-router';
import { useEffect } from 'react';

import { useMqSelect } from '@fhs/ui';
import { useIsNavigationReady } from '@fhs/utils';
import { LaunchDarklyFlag, useFlag } from '@fhs-legacy/frontend/src/state/launchdarkly';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';

import { getScreenTitleHeader } from '../../../components/get-screen-title-header';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function OffersStackLayout() {
  const isDesktop = useMqSelect({ $gteDesktop: true }, false);
  const isNavigationReady = useIsNavigationReady();
  const enableSimplyOfferUi = useFlag(LaunchDarklyFlag.ENABLE_SIMPLY_OFFER_UI);
  useEffect(() => {
    if (isNavigationReady && !enableSimplyOfferUi) {
      router.replace(routes.loyaltyOfferList);
    }
  }, [enableSimplyOfferUi, isNavigationReady]);
  return (
    <Stack
      screenOptions={{
        header: getScreenTitleHeader({
          cannotGoBackHref: '/v2/menu',
          showDivider: true,
        }),
        headerShown: !isDesktop,
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen
        name="details/[offerId]"
        options={{
          presentation: 'containedTransparentModal',
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="guide/[offerId]"
        options={{
          presentation: 'containedTransparentModal',
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="all"
        options={{
          title: 'See All Offers',
        }}
      />
    </Stack>
  );
}
